import * as React from "react";
import Button from "@mui/material/Button";
import { styled, useTheme } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import logo from "../../images/logo.png";
import img2 from "../../images/gold-coin.svg";
import img3 from "../../images/sega-coin.svg";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const CongratsPage = () => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const theme = useTheme(); // Ensure useTheme is properly used here

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button variant="outlined" onClick={handleClickOpen}>
        {t('congratsPage.demoButton')}
      </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        className="first_modal"
      >
        <IconButton
          aria-label={t('congratsPage.close')}
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent
          sx={{
            background: theme.palette.custom.black2_light2,
            color: theme.palette.custom.white_gray,
          }}
        >
          <DialogTitle className="modal_hedingimg" id="customized-dialog-title">
            {t('congratsPage.welcomeTo')} <img className="header-logo" src={logo} alt="logo" />
          </DialogTitle>

          <Grid
            container
            spacing={{ xs: 4, sm: 3, md: 4 }}
            style={{ justifyContent: "center" }}
          >
            <Grid item xs={12}>
              <div className="card_upar">
                <Typography variant="h1" component="h3">
                  {t('congratsPage.congratulations')}
                </Typography>
                <Typography variant="h1" component="h4">
                  <Typography
                    sx={{
                      color: theme.palette.custom.red_light,
                    }}
                    variant="p"
                    component="span"
                  >
                    {t('congratsPage.goldCoinsAmount')}&nbsp;
                  </Typography>
                  &
                  <br />
                  <Typography
                    sx={{
                      color: theme.palette.custom.green_green,
                    }}
                    variant="p"
                    component="span"
                  >
                    {t('congratsPage.sweepstakesCoinsAmount')}&nbsp;
                  </Typography>
                  {t('congratsPage.forFree')}
                </Typography>
                <Typography variant="h1" component="h5">
                  {t('congratsPage.description')}
                </Typography>
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={{ xs: 4, sm: 3, md: 4 }}
            style={{ justifyContent: "center" }}
            className="space_t"
          >
            <Grid item xs={6}>
              <div className="modal_img_info">
                <div className="info_card">
                  <img src={img2} alt="logo" className="sidebar-coin" />
                  <Typography variant="p" component="h3">
                    {t('congratsPage.playWith')}&nbsp;
                    <Typography
                      sx={{
                        color: theme.palette.custom.green_green,
                      }}
                      variant="p"
                      component="span"
                    >
                      {t('congratsPage.scAbbr')} <br /> {t('congratsPage.sweepstakesCoins')} <br />
                    </Typography>
                    {t('congratsPage.forRealCashPrizes')}
                  </Typography>
                </div>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className="modal_img_info border-left"
                sx={{
                  border: theme.palette.custom.gray_border,
                }}
              >
                <div className="info_card">
                  <img src={img3} alt="logo" className="sidebar-coin" />
                  <Typography variant="p" component="h3">
                    {t('congratsPage.playWith')}&nbsp;
                    <Typography
                      sx={{
                        color: theme.palette.custom.red_light,
                      }}
                      variant="p"
                      component="span"
                    >
                      {t('congratsPage.gcAbbr')} <br /> {t('congratsPage.goldCoins')} <br />
                    </Typography>
                    {t('congratsPage.forFun')}
                  </Typography>
                </div>
              </div>
            </Grid>

            <Grid item xs={12}>
              <form>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id=""
                  />
                  <label class="form-check-label" for="">
                    {t('congratsPage.agreeTerms')}{" "}
                  </label>
                </div>
              </form>
              <Button
                className="full_btn"
                size="medium"
                sx={{
                  background: theme.palette.custom.pink_bg,
                  color: theme.palette.custom.white_gray,
                }}
              >
                {t('congratsPage.startPlaying')}
              </Button>
            </Grid>

            <Typography variant="h1" component="h6">
              {t('congratsPage.noPurchaseNecessary')}
            </Typography>
          </Grid>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};

export default CongratsPage;
